import React, { Component } from 'react';
import Select from 'react-select';
import { withAuthorization } from '../Session';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import {TIMEZONE_OPTIONS} from '../../constants/timezones';
import {COUNTRY_OPTIONS} from '../../constants/countries';
import * as REGISTRATION from '../../constants/registration';

const RegistrationPage = () => (
  <div id="page-home" className="reg-page">
    <AboutUserForm />
  </div>
);

const INITIAL_STATE = {
  fname: '', lname: '', 
  linkedin: '', country: '', timezone: '', prof_background: '', edu_background: '',
  edu_level: '', work_duration: '',
  hackathon_role: ''
};

class AboutUserFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE};
  }

  componentDidMount(){
    let uid = this.props.firebase.auth.currentUser.uid;
    this.props.firebase.user(uid).on("value", snapshot => {
      const userObject = snapshot.val();
      //console.log("ABOUT USER OBJ: ", userObject);
      if (userObject) {
        let {fname, lname, linkedin, country, timezone, prof_background, edu_background, hackathon_role, 
          edu_level, work_duration} = userObject;
        this.setState({fname, lname, 
          linkedin: linkedin||'', country, timezone, prof_background, edu_background, hackathon_role: hackathon_role||'', edu_level, work_duration});
      }
    }, function (errorObject) {
      console.log("The read failed: " + errorObject.code);
    });
  }

  componentWillUnmount(){
    if(this.props.firebase.auth.currentUser && this.props.firebase.auth.currentUser.uid){
      //console.log("ABOUT UNMOUNT");
      this.props.firebase.user(this.props.firebase.auth.currentUser.uid).off();
    }
  }

  onSubmit = event => {
    const {linkedin, country, timezone, prof_background, edu_background, hackathon_role, edu_level, work_duration} = this.state;

    this.saveToDB(linkedin, country, timezone, prof_background, edu_background, hackathon_role, edu_level, work_duration)
    // go to next page
    let isMentor = hackathon_role.value === REGISTRATION.HACKATION_ROLES.mentor;
    if(isMentor) {
      this.props.history.push(ROUTES.REG_MENTOR);
    } else {
      this.props.history.push(ROUTES.REG_COMPETITOR);
    }
    
    event.preventDefault();
  }

  saveToDB (linkedin= '', country= '', timezone= '', prof_background= '', edu_background= '', hackathon_role= '', edu_level='', work_duration=''){
    let desc = {linkedin, country, timezone, prof_background, edu_background, hackathon_role, edu_level, work_duration,
      lastUpdated: Date.now()}
    //update to database
    let uid = this.props.firebase.auth.currentUser.uid
    this.props.firebase.user(uid).update(desc);
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  onSelectChange = (selectedOption, action) =>{
    this.setState({ [action.name]: selectedOption });
  }



  render() {
    const {fname, 
      linkedin, country, timezone, prof_background, edu_background, hackathon_role,
      edu_level, work_duration,
      error} = this.state;

    const isInvalid = !country || !timezone || !hackathon_role;
    
    return (
      <div className="bound-box">
        <h1>Hi {fname}, tell us a little about you</h1>
        <p>Section 1 of 2. Make sure you complete both sections to register.</p>
        <p>Share what you would like others to know about you. This info will be synced to your profile. Not to worry, you can edit it later</p>
        <form onSubmit={this.onSubmit}>
          <div><input id="linkedin" name="linkedin" value={linkedin} onChange={this.onChange} type="text" placeholder="LinkedIn URL" /></div>
          <br />
          <Select id="country" name="country" value={country} onChange={this.onSelectChange} options={COUNTRY_OPTIONS} placeholder="Country*" />
          <br />
          <Select id="timezone" name="timezone" value={timezone} onChange={this.onSelectChange} options={TIMEZONE_OPTIONS} placeholder="Timezone*" />
          <br />
          <Select id="edu_level" name="edu_level" value={edu_level} onChange={this.onSelectChange} options={REGISTRATION.EDUCATION_LEVEL} placeholder="What is your highest educational level?*" />
          <br/>
          <Select id="edu_background" name="edu_background" value={edu_background} onChange={this.onSelectChange} options={REGISTRATION.EDU_BACKGROUND_OPTIONS} placeholder="Academic background*" />
          <br/>
          <Select id="prof_background" name="prof_background" value={prof_background} onChange={this.onSelectChange} options={REGISTRATION.PROF_BACKGROUND_OPTIONS} placeholder="Professional background*" />
          <br />
          <Select id="work_duration" name="work_duration" value={work_duration} onChange={this.onSelectChange} options={REGISTRATION.WORKING_DURATION} placeholder="How long have you been working full time?*" />
          <br/>
          <Select id="hackathon_role" name="hackathon_role" value={hackathon_role} onChange={this.onSelectChange} options={REGISTRATION.HACKATHON_ROLE_OPTIONS} placeholder="Are you a hacker or a mentor?*" />
          <br />
          <button id="btn_next" disabled={isInvalid} type="submit">Next</button>
          <label htmlFor="btn_next">Please fill out all fields to enable Next button</label>
          {error && <p>{error.message}</p>}
        </form>



      </div>
    );
  }

}




const condition = authUser => !!authUser;

const AboutUserForm = compose(
  withRouter,
  withFirebase,
)(AboutUserFormBase);

export { AboutUserForm };
export default withAuthorization(condition)(RegistrationPage);
